import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { fetchCases, default as fallbackProjects } from "../../api/projects";
import SectionTitle from "../SectionTitle/SectionTitle";
import ImageWithGoogleDrive from "../ImageWithGoogleDrive/ImageWithGoogleDrive";
import "./ProjectSection.css";
import ContactSection from "../Contactsection/ContactSection";

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const ProjectSection = (props) => {
    const { hclass, ShowSectionTitle = true, sliceStart = 0, sliceEnd = 3, } = props;
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const loadProjects = async () => {
            try {
                setLoading(true);
                setError(null);
                
                const apiProjects = await fetchCases();
                
                if (apiProjects && apiProjects.length > 0) {
                    // Filter only visible projects
                    const visibleProjects = apiProjects.filter(project => project.isVisible === true);
                    
                    if (visibleProjects.length > 0) {
                        setProjects(visibleProjects);
                    } else {
                        // If no visible projects from API, use fallback
                        console.warn('No visible projects found in API response, using fallback data');
                        setProjects(fallbackProjects);
                    }
                } else {
                    // Fallback to static data if API returns empty
                    console.warn('API returned empty response, using fallback data');
                    setProjects(fallbackProjects);
                }
            } catch (err) {
                console.error('Error loading projects:', err);
                setError(err.message);
                // Fallback to static data on error
                setProjects(fallbackProjects);
            } finally {
                setLoading(false);
            }
        };

        loadProjects();
    }, []);

    // Loading state
    if (loading) {
        return (
            <section className={hclass}>
                <div className="container">
                    {ShowSectionTitle && (
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-12">
                                <SectionTitle title={'Our Portfolio'} subtitle={'All The Great Work That We Done'} />
                            </div>
                            <div className="col-lg-6 col-12">
                                <div className="project_btn">
                                    <Link to="/project" className="theme-btn">See All Cases </Link>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="project_wrapper">
                        <div className="row">
                            <div className="col-12 text-center">
                                <div className="loading-spinner">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                    <p className="mt-3">Cargando casos médicos...</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    // Error state (optional - you can remove this if you want to always show fallback)
    if (error && projects.length === 0) {
        return (
            <section className={hclass}>
                <div className="container">
                    {ShowSectionTitle && (
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-12">
                                <SectionTitle title={'Our Portfolio'} subtitle={'All The Great Work That We Done'} />
                            </div>
                            <div className="col-lg-6 col-12">
                                <div className="project_btn">
                                    <Link to="/project" className="theme-btn">See All Cases </Link>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="project_wrapper">
                        <div className="row">
                            <div className="col-12 text-center">
                                <div className="error-message">
                                    <p className="text-danger">Error al cargar los casos: {error}</p>
                                    <p className="text-muted">Mostrando datos de respaldo</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className={hclass}>
            <div className="container">
                {ShowSectionTitle && (
                <div className="row align-items-center">
                    <div className="col-lg-6 col-12">
                        <SectionTitle title={'Our Portfolio'} subtitle={'All The Great Work That We Done'} />
                    </div>
                    <div className="col-lg-6 col-12">
                        <div className="project_btn">
                            <Link to="/project" className="theme-btn">See All Cases </Link>
                        </div>
                    </div>
                </div>
                )}
                <div className="project_wrapper">
                    <div className="row">
                        {projects.slice(sliceStart, sliceEnd).map((project, pitem) => (
                            <div className="col-lg-4 col-md-6 col-12" key={pitem}>
                                <div className="project_card">
                                    {project.pimg1 ? (
                                        <ImageWithGoogleDrive 
                                            src={project.pimg1} 
                                            alt={project.title}
                                            fallback={
                                                <img 
                                                    src={require('../../images/porfolio/1.png')} 
                                                    alt={project.title}
                                                />
                                            }
                                        />
                                    ) : (
                                        <img 
                                            src={require('../../images/porfolio/1.png')} 
                                            alt={project.title}
                                        />
                                    )}
                                    <div className="text">
                                        <h2>
                                            <Link onClick={ClickHandler} to={`/portfolio/${project.slug}`}>
                                                {project.title}
                                            </Link>
                                        </h2>
                                        <span>{project.subtitle}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <ContactSection />
            </div>
        </section>
    )
}
export default ProjectSection;





